module.exports = __webpack_public_path__ + "assets/img/lc-up-to-date.svg";